import { combineStyles, fonts, media, mixins } from '@blend/consumer-components';
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';

import { AvoidWidowText, ProvideTimers, TimerProps } from '@blend/shared-react';
import { Tiempos } from 'login-components/Common/PaneLayout/paneStyles';
import { loginBackgroundDynamicColor } from 'login-stylesheets/deploymentColors';

export interface AppHeaderOwnProps {
  text: string;
}

const styles = StyleSheet.create({
  appHeader: combineStyles(Tiempos, mixins.margin(30, 'auto', 30), {
    color: loginBackgroundDynamicColor,
    fontSize: 34,
    fontWeight: fonts.weight.book,
    lineHeight: '1.6em',
    maxWidth: 750,
    outline: 'none',
    textAlign: 'center',
    [media.smallView]: combineStyles(mixins.margin(10, 'auto', '1.8em'), {
      lineHeight: '28px',
      fontSize: 28,
    }),
  }),
});

type AppHeaderProps = AppHeaderOwnProps & TimerProps;
class AppHeader extends React.Component<AppHeaderProps, {}> {
  headerRef = React.createRef<HTMLHeadingElement>();

  UNSAFE_componentWillReceiveProps() {
    const { reactSafeSetTimeout } = this.props;
    // For ADA reasons, focus on this when changing state (which is effectively changing this)
    reactSafeSetTimeout(() => {
      const headerEl = this.headerRef.current;
      /* istanbul ignore next */
      if (headerEl) headerEl.focus();
    });
  }

  render() {
    const { text } = this.props;
    return (
      <h1 id="it-AppHeader" ref={this.headerRef} className={css(styles.appHeader)} tabIndex={-1}>
        {text && <AvoidWidowText text={text} />}
      </h1>
    );
  }
}

export default (props: AppHeaderOwnProps) => (
  <ProvideTimers render={timerProps => <AppHeader {...props} {...timerProps} />} />
);
